import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'lib-email-changed-dialog',
  templateUrl: './email-changed-dialog.component.html',
  styleUrls: ['./email-changed-dialog.component.scss'],
})
export class EmailChangedDialogComponent {}
